import { Theme } from '@mui/material/styles';

import { Brand } from '@newfold/tokens';

import { PaletteMode } from '../../themeDefault';
import {
  createBluehostRevampTheme,
  getBluehostRevampGlobalStyles,
} from './bluehost';
import {
  createHostgatorRevampTheme,
  getHostgatorRevampGlobalStyles,
} from './hostgator';

export type RevampThemeBrand = 'bluehost' | 'hostgator';

export const getRevampThemeBrand = (
  brand?: string | null,
): RevampThemeBrand | null => {
  const normalizedBrand = brand?.toLowerCase();

  if (normalizedBrand === 'bluehost' || normalizedBrand === 'hostgator') {
    return normalizedBrand;
  }

  return null;
};

export const createRevampTheme = (
  mode: PaletteMode = 'light',
  brand: Brand,
): Theme => {
  if (getRevampThemeBrand(brand) === 'hostgator') {
    return createHostgatorRevampTheme(mode, brand);
  }

  return createBluehostRevampTheme(mode, brand);
};

export const getRevampGlobalStyles = (
  brand: Brand | string | null | undefined,
  selector: string,
) => {
  const revampBrand = getRevampThemeBrand(brand);

  if (revampBrand === 'hostgator') {
    return getHostgatorRevampGlobalStyles(selector);
  }

  if (revampBrand === 'bluehost') {
    return getBluehostRevampGlobalStyles(selector);
  }

  return {};
};
